module.exports = __webpack_public_path__ + "static/media/gulp.5159ea36.svg";